import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';
import TabsList from '../TabsList';

import styles from './CourseHeader.module.scss';
import usePresenter from './CourseHeader.presenter';
import getProps from './CourseHeader.props';
import { CourseHeaderCombinedProps } from './types';


const CourseHeader: React.FC<CourseHeaderCombinedProps> = (props) => {
  const {
    className,
    classes,
    button,
    text,
    tabsList,
    divider,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.courseHeader;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.content, classes?.content)}>
        <div className={cx(styles.topContent, classes?.topContent)}>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}/>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
        <TabsList
          className={cx(styles.tabsList, classes?.tabsList)}
          {...internalProps.tabsList}
          {...tabsList}/>
      </div>
      <Divider
        className={cx(styles.divider, classes?.divider)}
        {...internalProps.divider}
        {...divider}/>
    </div>
  );
};

export default CourseHeader;

